import type { SVGProps } from 'react';
const SvgMeetingRoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3Zm-4 5v2h2v-2h-2Z"
    />
  </svg>
);
export default SvgMeetingRoom;
